module.exports = __webpack_public_path__ + "img/icon_download.2e0c2504.svg";